import { useI18n } from '../../../../i18n/i18n'
import './servicos-painel.scss'

type Servico = { emoji: string; titulo: string; texto: string; casos: string[] }

export function ServicosPainel() {
  const { t } = useI18n()
  const lista = t('servicos.items') as Servico[]
  return (
    <section className="servicos-painel">
      <div className="servicos-painel__hero">
        <span className="eyebrow">{t('servicos.eyebrow')}</span>
        <h1 className="section-heading">{t('servicos.title')}</h1>
        <p>{t('servicos.sub')}</p>
      </div>

      <div className="servicos-painel__list">
        {lista.map((c, i) => (
          <article className="servico" key={i}>
            <div className="servico__aside">
              <span className="servico__emoji" aria-hidden>{c.emoji}</span>
              <h2>{c.titulo}</h2>
            </div>
            <div className="servico__body">
              <p>{c.texto}</p>
              <ul>
                {c.casos.map((caso, idx) => (
                  <li key={idx}>{caso}</li>
                ))}
              </ul>
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}
